import { useCreate } from '@refinedev/core';
import { FileData } from 'src/data-capture/hooks/file-uploads/types';

type UrlResponse = {
  url: string;
};

export const useFileTemporaryLinkMutation = () => {
  const { mutateAsync, isLoading, isError } = useCreate<Response>();

  const createLink = async (fileId: FileData['id']): Promise<UrlResponse> => {
    const result = await mutateAsync({
      resource: `files/${fileId}/file-links`,
      values: {},
    });

    return result.data;
  };

  return {
    createLink,
    isLoading,
    isError,
  };
};
